import { action } from 'cdpro-redux-utils'

import { IWbUserInfo } from '@interco/inter-webview-bridge'

export const Types = {
  SET_PIX: 'SET_PIX',
  SET_USER: 'SET_USER',
  SET_INTL: 'SET_INTL',
}

const setPixKey = action<{ pix: PixFormated }>(Types.SET_PIX)

const setUser = action<{ user: IWbUserInfo & { userTestingType?: 'A' | 'B' } }>(Types.SET_USER)

const setIntl = action<{ intl: IntlLanguageTexts }>(Types.SET_INTL)

export { setPixKey, setUser, setIntl }
